<template>
  <div class="diy-login-page">
    <div class="diy-login-page__logo">
      <transition name="scale-in">
        <img v-if="showLogo" :src="diyLogo" alt="diy-logo" />
      </transition>
    </div>
    <div class="diy-login-page__wrapper">
      <!-- login and password reset forms -->
      <LoginForm v-if="routeName === 'login'" />
      <PasswordResetForm
        v-else-if="routeName === 'password-reset'"
        :user-id="pw_reset_userId"
        :token="pw_reset_token"
      />
      <!-- reset request form -->
      <PasswordResetRequestForm v-else-if="routeName === 'forgot-password'" />

      <div class="diy-login-page__brand">
        <p><span>DIY</span>Inbound</p>
        <img :src="inboundCycleLogo" alt="by-InboundCycle" />
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import DIYLogo from 'Images/logo/diy-logo-basic.png'
import InboundCycleLogo from 'Images/logo/inboundcycle-logo.png'
import LoginPageImage from 'Images/covers/login/login-bg.png'
// Components
import LoginForm from 'Components/Forms/LoginForm'
import PasswordResetForm from 'Components/Forms/PasswordResetForm'
import PasswordResetRequestForm from 'Components/Forms/PasswordResetRequestForm'

export default {
  name: 'UserLogin',
  components: {
    LoginForm,
    PasswordResetForm,
    PasswordResetRequestForm,
  },

  props: {
    pw_reset_userId: {
      type: String,
      default: undefined,
    },

    pw_reset_token: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      timeout: null,
      showLogo: false,
      diyLogo: DIYLogo,
      routeName: 'login',
      sendingData: false,
      inboundCycleLogo: InboundCycleLogo,
    }
  },

  computed: {
    backgroundImage() {
      return LoginPageImage
    },

    resetPasswordRequested() {
      return this.pw_reset_userId && this.pw_reset_token
    },

    isRequestedPage() {
      return (page) => {
        return this.$route.name === page
      }
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.routeName = to.name
    next()
  },

  created() {
    this.routeName = this.$route.name
    this.timeout = setTimeout(() => {
      this.showLogo = true
    }, 250)
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
.diy-login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 60px 30px;
  height: 100vh;
  background: #fff url('../../assets/img/covers/login/login-bg.png') no-repeat;
  background-position: center -100px;
  background-size: stretch;
  overflow: hidden;
}

.diy-login-page__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.diy-login-page__logo {
  text-align: center;
  min-height: 54px;
}

.diy-login-page__logo img {
  height: 50px;
}

.diy-login-page__wrapper {
  display: block;
  position: relative;
  max-width: 450px;
  min-width: 250px;
  padding: 30px 30px 40px;
  margin: 40px auto 0;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.9s;
}

.diy-login-page__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 12px;
  letter-spacing: 0.2px;
  font-weight: 800;
  color: var(--c-magenta-500);
  gap: 5px;
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid var(--c-secondary-400);
}

.diy-login-page__brand span {
  color: var(--c-primary);
}

.diy-login-page__brand img {
  height: 15px;
}

/* transition */
.from-right-enter-active,
.from-right-leave-active {
  transition: opacity 0.3s, transform 0.3s, max-height 0.6s;
  max-height: 440px;
  overflow: hidden;
}

.from-right-enter {
  opacity: 0;
  transform: translateX(-80%);
  max-height: 290px;
}

.from-right-leave-to {
  opacity: 0;
  transform: translateX(-80%);
  max-height: 265px;
}

/* Responsive ----------- */
@media (max-width: 580px) {
  .diy-login-page__wrapper {
    padding: 20px 15px;
  }

  .v-form.diy-login-page__form label {
    font-size: 14px;
  }

  .submit-button {
    width: 100%;
  }
}
</style>
